import { useMutation } from "react-query";
import { addCarrierProgram } from "../../../../../actions/Utilities/CarrierProgram";
const useAddCarrierProgram = () => {
  //Add new carrier function
  return useMutation(addCarrierProgram);
};
export default useAddCarrierProgram;
